import { resourceIconName, resourceChipClass, resourceOpensNewTab } from "./resource_config";
import { iconPlaceholder } from "./massimo_icons";
import safeParsedHref from "./safe_href";
import escapeAttr from "./escape_attr";
import linkAttributes from "./link_attributes";

// Chips also render into composer pills, which never reach the sanitizer, so the URL is checked here.
export default function renderResourceChip(text, href, type) {
  const classes = resourceChipClass(type);
  const icon = iconPlaceholder(resourceIconName(type));
  // text can be user-supplied (context pill label/sublabel), so escape it before it hits innerHTML.
  const safeText = escapeAttr(text);
  const url = safeParsedHref(href);
  if (!url) {
    return `<span class="${classes}">${icon}${safeText}</span>`;
  }
  const inPlace = url.origin === window.location.origin && !resourceOpensNewTab(type);
  return `<a href="${escapeAttr(href)}"${linkAttributes({ inPlace })} class="${classes}">${icon}${safeText}</a>`;
}
